<template>
    <div style="width:90%">
        <div class="container_body">
            <header class="header_nav">
                <el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
                    <el-form-item label="资产名称" class='tiny'>
                        <el-input style="width: 200px;" v-model="searchInfo.name" placeholder="请输入资产名称"></el-input>
                    </el-form-item>
                    <el-form-item style="width:40%">
                        <template>
                            <el-button type="primary" @click="search">查询</el-button>
                            <el-button type="primary" @click="empty">清空</el-button>
                        </template>
                    </el-form-item>
                </el-form>
            </header>
        </div>


        <el-table :data="list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
            element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-form inline class="demo-table-expand">
                        <el-form-item label="发行总量:">
                            <span>{{ props.row.total }}</span>
                        </el-form-item>
                        <el-form-item label="转账手续费比例:" label-width="115px">
                            <span>{{ props.row.saleSeviceRadio }}</span>
                        </el-form-item>
                        <el-form-item label="提币手续费(固定个数):" label-width="155px">
                            <span>{{ props.row.bcWithdrawCommission }}</span>
                        </el-form-item>
                        <el-form-item label="提币手续费比例:" label-width="115px">
                            <span>{{ props.row.bcWithdrawCommissionRate }}</span>
                        </el-form-item>
                        <el-form-item label="最小提现数量:">
                            <span>{{ props.row.minWithdrawNumber }}</span>
                        </el-form-item>
                        <el-form-item label="最大提现数量:">
                            <span>{{ props.row.maxWithdrawNumber }}</span>
                        </el-form-item>
                        <el-form-item label="最小转账数量:">
                            <span>{{ props.row.minTransferNumber }}</span>
                        </el-form-item>
                        <el-form-item label="最大转账数量:">
                            <span>{{ props.row.maxTransferNumber }}</span>
                        </el-form-item>
                        <!-- <el-form-item label="上次登录日期">
                            <span>{{formartDate(props.row.lastActivityDate)}}</span>
                        </el-form-item> -->

                    </el-form>
                </template>
            </el-table-column>
            <el-table-column prop="id" label="序号" sortable align="center">
            </el-table-column>
            <el-table-column prop="name" label="资产名称" align="center" :formatter="changeNull"
                :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column prop="logo" label="资产logo" align="center" :formatter="changeNull">
                <template slot-scope="scope">
                    <img :src="scope.row.logo" style="width: 50px;" />
                </template>
            </el-table-column>
            <el-table-column prop="integralType" label="资产类别" align="center" width="100">
                <template slot-scope="scope">
                    <p v-if="scope.row.integralType==0">积分</p>
                    <p v-if="scope.row.integralType==1">ERC20</p>
                    <p v-if="scope.row.integralType==4">额度</p>
                </template>
            </el-table-column>



            <el-table-column prop="referPrice" label="参考价格" align="center" :formatter="changeNull"
                :show-overflow-tooltip="true">
            </el-table-column>


            <el-table-column prop="unitPrice" label="价格单位" align="center" :formatter="changeNull"
                :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <p v-if="scope.row.unitPrice==0">USDT</p>
                    <p v-if="scope.row.unitPrice==1">CNY</p>
                </template>
            </el-table-column>

            <el-table-column prop="withdrawStatus" label="提币状态" align="center" :formatter="changeNull"
                :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <p v-if="scope.row.withdrawStatus==1">是</p>
                    <p v-else>否</p>
                </template>
            </el-table-column>
            <el-table-column prop="bcWithdrawNumber" label="提币审核限制值" align="center" :formatter="changeNull"
                :show-overflow-tooltip="true">
            </el-table-column>


            <el-table-column prop="isCanPay" label="是否用于支付" align="center" :formatter="changeNull"
                :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <p v-if="scope.row.isCanPay">是</p>
                    <p v-else>否</p>
                </template>
            </el-table-column>

            <el-table-column prop="isCharge" label="是否用于充值" align="center" :formatter="changeNull"
                :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <p v-if="scope.row.isCharge">是</p>
                    <p v-else>否</p>
                </template>
            </el-table-column>


            <el-table-column prop="createDate" label="创建时间" align="center" width="200">
            </el-table-column>

            <el-table-column prop="status" label="状态" align="center" width="100">
                <template slot-scope="scope">
                    <p v-if="scope.row.status==0">禁用</p>
                    <p v-else>正常</p>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
                　　　　<template slot-scope="scope">
                    <el-button size="small" type="text" @click="editialogVisible(scope.row.id)">编辑</el-button>
                </template>
                　　</el-table-column>
        </el-table>

        <!-- 编辑 -->
        <el-dialog title="编辑" :visible.sync="editDialogVisible" width="50%" :close-on-click-modal="false">
            <div class="app-container">
                <el-form ref="form" :model="form" size="medium" style="margin-left: 30px;">
                    <el-form-item label="资产名称：">
                        <el-col :span="8" style="color: black;font-weight: 100;">
                            {{form.name}}
                        </el-col>
                    </el-form-item>
                    <el-form-item label="最小提币数量：">
                        <el-col :span="8">
                            <el-input v-model="form.minWithdrawNumber" />
                        </el-col>
                    </el-form-item>
                    <el-form-item label="最大提币数量：">
                        <el-col :span="8">
                            <el-input v-model="form.maxWithdrawNumber" />
                        </el-col>
                    </el-form-item>

                    <el-form-item label="参考价格(USDT)：">
                        <el-col :span="8">
                            <el-input v-model="form.referPrice" />
                        </el-col>
                    </el-form-item>
                    <el-form-item label="参考价格(CNY)：">
                        <el-col :span="8">
                            <el-input v-model="form.referCnyPrice" />
                        </el-col>
                    </el-form-item>
                    <el-form-item label="提币审核限制值：">
                        <el-col :span="8">
                            <el-input v-model="form.bcWithdrawNumber" />
                        </el-col>
                    </el-form-item>
                    <el-form-item label="转账手续费比例：">
                        <el-col :span="8">
                            <el-input v-model="form.saleSeviceRadio" />
                        </el-col>
                    </el-form-item>

                    <el-form-item label="最小转账数量：">
                        <el-col :span="8">
                            <el-input v-model="form.minTransferNumber" />
                        </el-col>
                    </el-form-item>
                    <el-form-item label="最大转账数量：">
                        <el-col :span="8">
                            <el-input v-model="form.maxTransferNumber" />
                        </el-col>
                    </el-form-item>

                    <el-form-item label="提币手续费(固定本币个数)：">
                        <el-col :span="8">
                            <el-input v-model="form.bcWithdrawCommission" />
                        </el-col>
                    </el-form-item>
                    <el-form-item label="提币手续费比例：">
                        <el-col :span="8">
                            <el-input v-model="form.bcWithdrawCommissionRate" />
                        </el-col>
                    </el-form-item>

                    <el-form-item label="是否可提币：">
                        <el-switch v-model="form.withdrawStatus" active-color="#13ce66" inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>

                    <el-form-item label="是否可充值：">
                        <el-switch v-model="form.isCharge" active-color="#13ce66" inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>

                    <el-form-item label="是否用于支付：">
                        <el-switch v-model="form.isCanPay" active-color="#13ce66" inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>



                    <el-form-item label="是否启用：">
                        <el-switch v-model="form.status" active-color="#13ce66" inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>

                    <el-form-item>
                        <el-button :loading="loading" type="primary" @click="toEdit()">提交</el-button>
                        <el-button @click="editDialogVisible = false">取 消</el-button>
                        <!-- <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                list: [], //用户列表
                editDialogVisible: false,
                showUrl: false,
                form: {},
                id: '',//id
                searchInfo: {},
            };
        },
        created() {
            this.getIntegralList();
        },
        methods: {
            empty() {
                this.searchInfo = {}
            },
            search() {
                this.getIntegralList()
            },
            //编辑弹框
            editialogVisible(id) {
                this.id = id
                this.form = {}
                this.$api.getIntegralInfoById(id).then((res) => {
                    if (res.state == 'success') {
                        this.form = res.data
                        if (res.data.status == "1") {
                            this.form.status = true
                        } else {
                            this.form.status = false
                        }
                        if (res.data.withdrawStatus == "1") {
                            this.form.withdrawStatus = true
                        } else {
                            this.form.withdrawStatus = false
                        }
                        this.editDialogVisible = true;
                    }
                })

            },
            toEdit() {
                if (this.id) {
                    //编辑
                    var data = this.form
                    if (this.form.status == true) {
                        data.status = "1"
                    } else {
                        data.status = "0"
                    }
                    if (this.form.withdrawStatus == true) {
                        data.withdrawStatus = "1"
                    } else {
                        data.withdrawStatus = "0"
                    }
                    // console.log(data)
                    this.$api.editIntegralInfoById(data).then((res) => {
                        if (res.state == 'success') {
                            this.$message({
                                message: res.data,
                                type: 'success'
                            });
                            this.editDialogVisible = false;
                            this.getIntegralList();
                        } else {
                            this.$message.error(res.data);
                        }
                    })
                }
            },
            headClass() {
                return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
            },
            changeNull(row, column, cellValue) {
                if (cellValue) {
                    return cellValue;
                } else {
                    return "暂无";
                }
            },
            getIntegralList() {
                this.loading = true
                var data = {
                    name: this.searchInfo.name,
                }
                this.$api.getIntegralList(data).then((res) => { //资产列表
                    // console.log(res)
                    if (res.state == 'success') {
                        this.list = res.data
                        this.loading = false
                    }
                })
            },
            beforeUploaden(file) {
                const isLt2M = file.size / 1024 / 1024 < 8;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 8MB!');
                }
                return isLt2M;
            },
        },

    };
</script>

<style>
    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 160px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
</style>